var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finish-mapping-step-tab"},[_c('div',{staticClass:"mb-2"},[_vm._v("Mapping result:")]),_c('TableView',{staticClass:"flex-1",attrs:{"headers":_vm.headers,"rows":_vm.finalResult}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }